<template lang="pug">
v-chip(
    v-bind="$attrs"
    :color="color"
  ) {{ text }}
</template>
<script>
export default {
  name: 'EvChip',
  props: {
    color: { type: String, default: 'grey' },
    text: { type: String, required: true },
  },
  data() {
    return {};
  },
};
</script>
